export const fatalError = {
  pageNotFound: 'Seite wurde nicht gefunden',
  anErrorOccured: 'Es ist ein Fehler aufgetreten',
}
